import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { deleteAprCostData } from 'src/app/page/masterdata/apr-rates/apr-rates.component';

@Component({
    selector: 'app-delete-dialog',
    templateUrl: './delete-aprcost.component.html',
    styleUrls: ['./delete-aprcost.component.scss'],
    standalone: false // NOSONAR
})
export class DeleteAPRCostComponent implements OnInit {
  content;
  id;
  pageName;

  constructor(public dialogRef: MatDialogRef<DeleteAPRCostComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: deleteAprCostData) {
    if (this.dataStore.page == 'apr rate') { // NOSONAR
      this.pageName = "APR Cost";
      this.content = this.dataStore.domicile;
      this.id = this.dataStore.id;
    }
  }

  ngOnInit(): void { // NOSONAR 

  }

  close(): void {
    this.dialogRef.close();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  public saveClick() {
    this.dialogRef.close({ data: this.id });
  }
}
